export const onLCP = () => {};
export const onINP = () => {};
export const onCLS = () => {};
export const onFID = () => {};
export const onFCP = () => {};
export const onTTFB = () => {};

export const getCLS = onCLS;
export const getFID = onFID;
export const getLCP = onLCP;
export const getFCP = onFCP;
export const getTTFB = onTTFB;
